export function getMilestoneAchievedRowKey(row: {
    applicationId: string;
    milestone: { sortOrder: number };
}): string {
    return `${row.applicationId}:${row.milestone.sortOrder}`;
}

/** Posting date per bulk row, keyed by `getMilestoneAchievedRowKey`. */
export type MilestonePostingDates = Record<string, string>;

export function buildDefaultMilestonePostingDates(
    rows: Array<{
        applicationId: string;
        milestone: { sortOrder: number; expectedDate: string };
    }>,
): MilestonePostingDates {
    return Object.fromEntries(
        rows.map((row) => [
            getMilestoneAchievedRowKey(row),
            row.milestone.expectedDate,
        ]),
    );
}

/** While the batch date is on it replaces every row's date; off, the rows keep theirs. */
export function resolveMilestonePostingDates(options: {
    rowDates: MilestonePostingDates;
    batchDate: string;
    isBatchDateOn: boolean;
}): MilestonePostingDates {
    const { rowDates, batchDate, isBatchDateOn } = options;
    if (!isBatchDateOn) {
        return rowDates;
    }
    return Object.fromEntries(
        Object.keys(rowDates).map((key) => [key, batchDate]),
    );
}

export function countMilestonesNotDueYet(options: {
    dates: MilestonePostingDates;
    today: string;
}): number {
    return Object.values(options.dates).filter((date) => date > options.today)
        .length;
}
